import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';


export const ROUTES: Routes = [
  {path: '', redirectTo: '/', pathMatch: 'full'},
  {path: '', loadChildren: () => import('../pages/lazy/public.module').then(m => m.PublicModule)},
  {path: 'vertical', loadChildren: () => import('../pages/lazy/vertical.module').then(m => m.VerticalModule)},
  {path: 'horizontal', loadChildren: () => import('../pages/lazy/horizontal.module').then(m => m.HorizontalModule)},
  {path: '**', loadChildren: () => import('../pages/lazy/vertical.module').then(m => m.VerticalModule)}
];

@NgModule({
  imports: [],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class RoutingModule {
}
